module.exports = __webpack_public_path__ + "img/79617600.4df3fd00.png";